import React from 'react'

export const CTSidebarData = [
    {
        title: 'Dashboard',
        link: '/ctdashboard',
    },
    {
        title: 'My Requests',
        link: '/ctrequests',
    },
    {
        title: 'My Customers',
        link: '/ctcustomers',
    },
    {
        title: 'Customer Reviews',
        link: '/ctreviews',
    },
]